<template>
	<div class="phi-slider-panel">
		<div class="modal-mask"
			v-bind:style="maskStyle"
			@click="maskClic()"
		></div>
		<div
			class="slider-panel"
			v-bind:style="panelStyle"
		>
			<div
				class="panel-grip"
				v-bind:class="{ bottom: side === 'top'}"
				v-if="side === 'top' || side === 'bottom'"
			></div>
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
    name: "phi-slider-panel",

	data() {
        return {
			panel: null,
			mask: null,
			panGap: 100,
			transitionTime: 220
		}
    },

	props: {
		open: {
			type: Boolean,
			required: false,
			default: false
		},

		side: {
			type: String,
			required: false,
			default: "left",
			validator: value => ["left", "right", "top", "bottom"].indexOf(value) >= 0
		},

		size: {
			type: String,
			required: false,
			default: "100px"
		},

		closeOnBlur: {
			type: Boolean,
			required: false,
			default: true
		},

		panelStyle: {
			type: Object,
			required: false,
			default: function () {
				return {
					backgroundColor: "#F3F3F3"
				}
			}
		},

		maskStyle: {
			type: Object,
			required: false,
			default: function () {
				return {
					backgroundColor: "rgba(0,0,0,0.5)"
				}
			}
		}
	},

	watch: {
		open: function(isOpen) {
			isOpen ? this.openPanel() : this.closePanel();
		}
	},

	methods: {
		openPanel(){
			this.modalMask.classList.add("open");

			switch(this.side){
				case "left":
					this.panel.classList.add("horizontal-open");
					this.panel.style.setProperty('--variable-width', this.getWidth());
				break;

				case "right":
					this.panel.classList.add("horizontal-open");
					this.panel.style.setProperty('--variable-width', "-" + this.getWidth());
				break;

				case "top":
					this.panel.classList.add("vertical-open");
					this.panel.style.setProperty('--variable-height', this.getHeight());
				break;

				case "bottom":
					this.panel.classList.add("vertical-open");
					this.panel.style.setProperty('--variable-height', "-" + this.getHeight());
				break;
			}

			this.panel.scrollTop = 0;
			this.$emit("opened", true);
		},

		closePanel(){
			switch(this.side){
				case "left":
					this.panel.style.setProperty('--variable-width', "-" + this.getWidth());
					this.panel.classList.remove("horizontal-open");
				break;

				case "right":
					this.panel.style.setProperty('--variable-width', this.getWidth());
					this.panel.classList.remove("horizontal-open");
				break;

				case "top":
					this.panel.style.setProperty('--variable-height', "-" + this.getHeight());
					this.panel.classList.remove("vertical-open");
				break;

				case "bottom":
					this.panel.style.setProperty('--variable-height', this.getHeight());
					this.panel.classList.remove("vertical-open");
				break;
			}

			this.modalMask.classList.remove("open");

			this.$emit("closed", true);
			this.$emit("update:open", false);
		},

		getWidth(){
			switch(this.side){
				case "left":
				case "right":
					return this.size;
				break;

				case "top":
				case "bottom":
					return window.innerWidth + "100vw";
				break;
			}
		},

		getHeight(){
			switch(this.side){
				case "left":
				case "right":
					return "100vh";
				break;

				case "top":
				case "bottom":
					return this.size;
				break;
			}
		},

		getLeft(){
			switch(this.side){
				case "left":
					return "-" + this.size;
				break;

				case "right":
					return "100vw";
				break;

				case "top":
				case "bottom":
					return "0px";
				break;
			}
		},

		getTop(){
			switch(this.side){
				case "left":
				case "right":
					return "0px";
				break;

				case "top":
					return "-" + this.size;
				break;

				case "bottom":
					return "100vh";
				break;
			}
		},

		resizePanel(){
			this.panelStyle.width 		= this.getWidth();
			this.panelStyle.height 		= this.getHeight();
			this.panelStyle.left 		= this.getLeft();
			this.panelStyle.top 		= this.getTop();
		},

		showPanel(){
			this.panelStyle.visibility 	= "visible";
			this.panelStyle.display 	= "block";
		},

		maskClic(){
			if(this.closeOnBlur){
				this.closePanel();
			}
			this.$emit('blur');
		},

		addGlobalEvents(){
			window.addEventListener("resize", evt => {
				//this.resizePanel();
			});
		}
	},

    mounted () {
		this.panel = this.$el.querySelector(".slider-panel");
		this.modalMask = this.$el.querySelector(".modal-mask");

		this.resizePanel();
		this.addGlobalEvents();

		document.body.appendChild(this.$el);
		this.showPanel();
    }
}

</script>

<style scoped>
.modal-mask{
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	visibility:hidden;
	display: none;
}

.modal-mask.open{
	visibility: visible;
	display: block;
}

.slider-panel {
	visibility: hidden;
	display: none;
    position: fixed;
    z-index: 9;
    overflow: hidden;
    transition: 220ms;
}

.panel-grip{
	position: absolute;
	width: 100%;
	height: 44px;
	background: rgba(0,0,0,0.0);
}

.panel-grip.bottom{
	bottom: 0;
}

.slider-panel.horizontal-open{
	--variable-width: 0;
	transform: translateX(var(--variable-width));
}

.slider-panel.vertical-open{
	--variable-height: 0;
	transform: translateY(var(--variable-height));
}
</style>